// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"styles_skeleton__278rb","shimmer":"styles_shimmer__9CyxL"};